import type { State } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/state/types';

export {
	ISSUE_LIMIT_WARNING,
	ISSUE_SEARCH_WARNING,
	NO_JSW_ACCESS_FOR_USER,
	PROJECT_LIMIT_EXCEPTION,
	PROJECT_LIMIT_WARNING,
	SORTED_PREVENT_ISSUE_RANKING_WARNING,
	REPARENT_CMP_TO_TMP_WARNING,
	REPARENT_TMP_TO_EXTERNAL_WARNING,
	type Flag,
	type Flags,
	type FlagKey,
	// eslint-disable-next-line jira/export/no-external-exports
} from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/state/domain/flags/types';

export const getFlags = (state: State) => state.domain.flags;
